import queryString from 'query-string'

import { LeadSources } from '@app/constants'

/**
 *
 * @param url Sample: https://www.elemy.com/parent-booking?utm_source=facebook&utm_medium=paid-social&utm_campaign=[Family][ACQ][ABA][BO][3]&utm_content=9%20v%201%20NBC&utm_term=[Family][ACQ][ABA][Interests][PA][Cities]&fbclid=IwAR0GwlolFE8LrCRg6ftFYSFk2EtvtLz9gWTaU_3XrFP2NUjyJQORhhXiB8Y
 */
export const detectLeadSourceByURL = (url: string, referer?: string) => {
  const parsedURL = queryString.parseUrl(url)
  const UTMSource = parsedURL.query?.utm_source && String(parsedURL.query?.utm_source).toLocaleLowerCase()
  const UTMMedium = parsedURL.query?.utm_medium && String(parsedURL.query?.utm_medium).toLocaleLowerCase()
  const fbclid = parsedURL.query?.fbclid
  const gclid = parsedURL.query?.gclid
  const msclkid = parsedURL.query?.msclkid

  switch (true) {
    case (UTMSource === 'google' && UTMMedium === 'cpc') || Boolean(gclid):
      return LeadSources.GoogleAds

    case UTMSource === 'facebook' && UTMMedium === 'paid-social':
      return LeadSources.FacebookPaid

    case UTMSource === 'google' && UTMMedium === 'yext':
      return LeadSources.GoogleMyBusiness

    case UTMSource === 'extnet' && UTMMedium === 'yext':
      return LeadSources.YextPartners

    case UTMSource === 'bing' && UTMMedium === 'yext':
      return LeadSources.GoogleMaps

    case (UTMSource === 'bing' && UTMMedium === 'cpc') || Boolean(msclkid):
      return LeadSources.BingPaid

    case referer?.includes('facebook') && Boolean(fbclid) && !UTMSource && !UTMMedium:
      return LeadSources.Facebook

    case referer?.includes('google') && !UTMSource && !UTMMedium:
      return LeadSources.GoogleOrganic

    case referer?.includes('bing') && !UTMSource && !UTMMedium:
      return LeadSources.BingOrganic

    case referer && !UTMSource && !UTMMedium:
      return LeadSources.Other

    case !referer && !UTMSource && !UTMMedium:
      return LeadSources.Direct

    default:
      return LeadSources.Direct
  }
}
